import { Table } from "@/features/Table";
import { useBulkDeleteControls } from "@/features/Edit/useBulkDeleteControls";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";
import { type A6TimeSerie, columns } from "./columns";
import { type FilterA6TimeSeriesSchema, FilterA6TimeSeries } from "./filter";

const client = Clients.A6;
const table_name = Tables.A6_TIME_SERIES;

export const A6TimeSeriesTable = () => {
  const { selectionActions, modal } = useBulkDeleteControls<A6TimeSerie>({
    client,
    table_name,
    resourceLabel: "Valorisation",
  });

  return (
    <>
      <Table<A6TimeSerie, FilterA6TimeSeriesSchema>
        label="Valorisation"
        client={client}
        table_name={table_name}
        columns={columns}
        filter={<FilterA6TimeSeries />}
        actions={[
          {
            label: "actions.new",
            route: `${client}/${table_name}/new`,
          },
        ]}
        enableRowSelection
        selectionActions={selectionActions}
      />
      {modal}
    </>
  );
};
